import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import BOLayout from '@/pages/back-office/BOLayout';
import TopBanner from '@/components/back-office/TopBanner';
import { useRestaurantsContext } from '@/contexts/RestaurantContext';
import Pen from '@/assets/media/SVGComponents/Pen';
import Trash from '@/assets/media/SVGComponents/Trash';
import Modal from '@/components/Modal';

const BOMenu = () => {
	const { selectedRestaurant } = useRestaurantsContext();
	const [menu, setMenu] = useState([]);
	const [menuId, setMenuId] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [canSubmit, setCanSubmit] = useState(false);
	const navigate = useNavigate();
	const role = JSON.parse(localStorage.getItem('role'));

	useEffect(() => {
		if ((!['super-admin', 'admin'].includes(role)) || selectedRestaurant.is_no_limit) {
			toast.info("Zone interdite", {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});

			setTimeout(() => navigate('/back-office'), 500);

			return;
		}

		const fetchData = async () => {
			try {
				const response = await axios.get(
					`${import.meta.env.VITE_API_URL}/api/restaurants/${selectedRestaurant?.id}/menu/list`
				);

				if (response.status === 200) {
					setMenu(response.data);
				}
			} catch (error) {
				if (error.response.status === 404) {
					toast.error('Aucun menu trouvé pour ce restaurant, veuillez en créer un', {
						position: 'top-center',
						autoClose: 1000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: true,
						theme: 'colored',
					});

					setTimeout(() => navigate(`/back-office/restaurants/${selectedRestaurant?.id}/menu/creation`), 2500);
				}
			}
		};

		fetchData();
	}, []);

	const handleOpenModal = (e, menuId) => {
		setShowModal(true);
		setMenuId(menuId);
	};

	const handleModalSubmit = async () => {
		try {
			await axios.delete(
				`${import.meta.env.VITE_API_URL}/api/back-office/restaurants/${selectedRestaurant?.id}/menu/${menuId}/delete`
			);

			toast.success('Menu supprimé', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});
		} catch (error) {
			console.error('Error deleting menu:', error);
			toast.error('Une erreur est survenue', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});
		}

		setTimeout(() => {
			navigate(0);
		}, 1500);
	};

	return (
		<BOLayout>
			<div className="mb-12">
				<TopBanner
					role={role}
					showButtons={'both'}
					navigationRouteText={'Créer une formule'}
					navigationRoute={`/back-office/restaurants/${selectedRestaurant?.id}/menu/creation`}
					hasTopRightButton={['super-admin', 'admin'].includes(role)}
				/>
			</div>

			{showModal && (
				<Modal
					type={'danger'}
					title={'Cette action est irréversible'}
					setShowModal={setShowModal}
					handleSubmit={handleModalSubmit}
				/>
			)}

			{menu.length > 0 ? (
				<div className="grid grid-cols-3 items-center justify-around">
					{menu.map((item) => (
						<div key={item.id} className="flex items-center gap-4">
							<div
								className="w-[100px] h-[100px] relative flex items-center justify-center"
								style={{
									backgroundImage: `url(${item.picture})`,
									backgroundSize: 'cover',
									backgroundPosition: 'center',
								}}
							>
								<div className="w-full h-full bg-black/40"></div>
								<p className="absolute inset-0 flex items-center justify-center font-bold text-xl text-center text-white">
									{item.name}
								</p>
							</div>

							<div className="flex flex-col text-2xl">
								<p className="mb-2 text-primary">{item.price}€</p>

								<div className="flex items-center gap-2">
									<button
										type="button"
										onClick={() =>
											navigate(
												`/back-office/restaurants/${selectedRestaurant?.id}/menu/${item.id}/edition`
											)
										}
									>
										<Pen color="#A2924A" width={30} height={30} />
									</button>

									<button type="button" onClick={(e) => handleOpenModal(e, item?.id)}>
										<Trash color="#A2924A" width={30} height={30} />
									</button>
								</div>
							</div>
						</div>
					))}
				</div>
			) : (
				<p>Aucun menu pour ce restaurant</p>
			)}
		</BOLayout>
	);
};

export default BOMenu;
